export enum EncodeTypes {
  MULTIPART = "MULTIPART",
  URLENCODED = "URLENCODED",
  JSON = "JSON",
}

export type EncodeType = keyof typeof EncodeTypes;
